/* pantallas-alumno (B): EL RECUADRO DE CONFIRMAR DENTRO DE LA PAGINA (piezas nuevas de la parte 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   No es una ventana: vive dentro de la pagina ("Submit your exam now?" y "Reset all flashcard
   progress?"). Radio 16, relleno 16; titulo 16 seminegrita, texto 14 #C8C8C8; los botones a la derecha
   desde 768 y, en el celular, a lo ancho con el principal ARRIBA (se pasan en el orden de la
   computadora: el secundario y luego el principal, y el celular los pinta al reves).
   Tonos: naranja suave para entregar el examen (#1A120C, borde #3A2414) y rojo suave para reiniciar
   (#1C1010, borde #3D1C1C).

   `compacto` (el de entregar el examen en computadora y tablet): desde 768 un solo bloque bajo
   (relleno 12 12 12 16, radio 14), titulo 15, texto 13.5 a la izquierda y los dos botones de 40 a la
   derecha, centrados en alto. En el celular es el normal. */
import React from 'react';
import { TONO_NARANJA_SUAVE, TONO_ROJO_SUAVE } from './estilos';

export default function RecuadroDeConfirmar({ titulo, texto, acciones, tono = 'naranja', compacto = false, testid, idTitulo }) {
  const c = tono === 'rojo' ? TONO_ROJO_SUAVE : TONO_NARANJA_SUAVE;
  const caja = compacto
    ? 'rounded-2xl border p-4 flex flex-col gap-3 md:flex-row md:items-center md:gap-4 md:rounded-[14px] md:py-3 md:pr-3 md:pl-4'
    : 'rounded-2xl border p-4 flex flex-col gap-3';
  return (
    <div role="group" aria-labelledby={idTitulo} data-testid={testid} data-tono={tono === 'rojo' ? 'rojo' : 'naranja'}
      data-compacto={compacto ? 'true' : undefined} className={caja} style={{ backgroundColor: c.fondo, borderColor: c.borde }}>
      <div className={compacto ? 'min-w-0 md:flex-1' : 'min-w-0'}>
        <p id={idTitulo} data-parte="titulo" className={`text-[16px] ${compacto ? 'md:text-[15px] ' : ''}leading-snug font-semibold text-[#F4F4F3] break-words`}>{titulo}</p>
        {texto ? <div data-parte="texto" className={`mt-1 text-[14px] ${compacto ? 'md:text-[13.5px] md:mt-0.5 ' : ''}leading-5 text-[#C8C8C8] break-words`}>{texto}</div> : null}
      </div>
      {acciones ? (
        <div data-parte="acciones" className={`flex flex-col-reverse gap-2 md:flex-row md:justify-end md:items-center ${compacto ? 'md:shrink-0' : ''}`.trim()}>
          {acciones}
        </div>
      ) : null}
    </div>
  );
}
